import { GET_WARNINGS, GET_WARNINGS_SUCCESS, GET_WARNINGS_ERROR} from './actionTypes';

export const getWarnings = (user) => {
    return {
        type: GET_WARNINGS,
        payload: { user }
    }
}

export const getWarningsSuccess = (warnings, message) => {
    return {
        type: GET_WARNINGS_SUCCESS,
        payload: {warnings, message}
    }
}

export const getWarningsError = (message) => {
    return {
        type: GET_WARNINGS_ERROR,
        payload: message
    }
}
